<template>
  <div>
    <v-container>
      <v-card>
        <v-card-text style="padding: 0px">
          <template>
            <v-toolbar color="primary" light>
              <v-toolbar-title class="white--text">Promotions</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items class="hidden-sm-and-down">
                <v-btn
                  color="white"
                  dark
                  flat
                  @click="dialog = true"
                  :disabled="!vid"
                  >Add New</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
          </template></v-card-text
        ></v-card
      ></v-container
    >
    <v-container>
      <v-toolbar flat color="white" dense style="margin-bottom: 0px">
        <v-btn color="success" small @click="loadPromotions()"
          ><v-icon>mdi-refresh</v-icon> Refresh</v-btn
        >
        <v-btn
          color="danger"
          class="white--text"
          small
          @click="deletePromotion()"
          :disabled="!selectedPromotions.length > 0"
          ><v-icon>mdi-delete</v-icon> Delete</v-btn
        >
        <v-btn
          color="primary"
          small
          @click="editPromotion()"
          :disabled="!(selectedPromotions.length == 1)"
          ><v-icon>mdi-lead-pencil</v-icon> Edit</v-btn
        >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <div style="width: 200px">
            <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </div>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="promotions"
        :search="search"
        :loading="true"
        item-key="id"
        v-model="selectedPromotions"
        select-all
        dense
        class="elevation-1"
      >
        <template slot="headerCell" slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-primary text--darken-3"
            v-text="header.text"
          ></span>
        </template>

        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              v-model="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td>
            <img
              :src="props.item.image"
              style="width: 75px; height: 75px; object-fit: cover"
            />
          </td>
          <td>{{ props.item.name }}</td>
          <td class="text-xs-center text-md-center">
            <v-switch
              v-model="props.item.active"
              color="primary"
              class="v-input--reverse"
              style="justify-content: center"
              hide-details
              @change="updateActive(props.item.id, props.item.active)"
            >
              <template slot="label"> Active </template>
            </v-switch>
          </td>
          <td>
            <v-chip
              color="green"
              text-color="white"
              :key="i"
              v-for="(p,i) in props.item.products"
            >
              <v-avatar class="green darken-4">
                <img :src="p.image" />
              </v-avatar>
              {{ p.name }}
            </v-chip>
          </td>
        </template>
      </v-data-table>

      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-card>
          <v-card-title class="text-primary">
            <span class="headline">New Promotion</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex
                    xs4
                    sm4
                    md4
                    align-center
                    text-xs-center
                    style="position: relative"
                  >
                    <img
                      v-if="promotion.image != ''"
                      @click="$refs.image.click()"
                      :src="promotion.image"
                      style="width: 150px; height: 150px; object-fit: cover"
                    />
                    <img
                      v-else
                      src="img/image.jpg"
                      @click="$refs.image.click()"
                      style="width: 150px; height: 150px; object-fit: cover"
                    />
                    <v-flex
                      v-if="uploading"
                      d-flex
                      align-center
                      align-content-center
                      style="
                        position: absolute;
                        left: 50%;
                        margin-left: -75px;
                        top: 0;
                        width: 150px;
                        height: 150px;
                        background: rgba(0, 0, 0, 0.5);
                      "
                    >
                      <v-progress-circular
                        :value="progress"
                        color="primary lighten-2"
                        size="75"
                      ></v-progress-circular>
                    </v-flex>
                    <v-text-field
                      @click="$refs.image.click()"
                      color="green"
                      placeholder="Select Image"
                      readonly
                      :value="promotion.file.name"
                      :rules="promotion.fileRules"
                    ></v-text-field>
                    <input
                      type="file"
                      style="display: none"
                      ref="image"
                      accept="image/*"
                      @change="pickFile($event)"
                      required
                    />
                  </v-flex>
                  <v-flex xs8 sm8 md8>
                    <v-text-field
                      label="Name*"
                      :rules="promotion.nameRules"
                      required
                      v-model="promotion.name"
                    ></v-text-field>
                    <v-autocomplete
                      v-model="promotion.products"
                      :items="products"
                      item-text="name"
                      item-value="id"
                      label="Products"
                      single-line
                      small-chips
                      dense
                      :allow-overflow="false"
                      multiple
                    >
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          class="chip--select-multi"
                          @input="remove(data.item)"
                        >
                          <v-avatar>
                            <img :src="data.item.image" />
                          </v-avatar>
                          {{ data.item.name }}
                        </v-chip>
                      </template>
                      <template v-slot="item" slot-scope="data">
                        <template v-if="(typeof data.item !== 'object')">
                          <v-list-tile-content
                            v-text="data.item"
                          ></v-list-tile-content>
                        </template>
                        <template v-else>
                          <v-list-tile-content>
                            <v-list-tile-title
                              v-html="data.item.name"
                            ></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-html="data.item.group"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <v-switch
                      v-model="promotion.active"
                      label="Available"
                      color="success"
                    ></v-switch>
                    <v-checkbox
                      v-model="promotion.push_notification"
                      label="Notification"
                      color="primary"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              small
              outline
              @click.native="
                dialog = false;
                resetForm();"
              >
              Close
              </v-btn>
            <v-btn
              color="primary darken-1"
              small
              :disabled="!valid || uploading"
              @click.native="addPromotion()"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog1" persistent max-width="800px">
        <v-card>
          <v-card-title class="text-primary">
            <span class="headline">Update Collection</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid1">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex
                    xs4
                    sm4
                    md4
                    align-center
                    text-xs-center
                    style="position: relative"
                  >
                    <img
                      v-if="promotion.image != ''"
                      @click="$refs.image.click()"
                      :src="promotion.image"
                      style="width: 150px; height: 150px; object-fit: cover"
                    />
                    <img
                      v-else
                      src="img/image.jpg"
                      @click="$refs.image.click()"
                      style="width: 150px; height: 150px; object-fit: cover"
                    />
                    <v-flex
                      v-if="uploading"
                      d-flex
                      align-center
                      align-content-center
                      style="
                        position: absolute;
                        left: 50%;
                        margin-left: -75px;
                        top: 0;
                        width: 150px;
                        height: 150px;
                        background: rgba(0, 0, 0, 0.5);
                      "
                    >
                      <v-progress-circular
                        :value="progress"
                        color="primary lighten-2"
                        size="75"
                      ></v-progress-circular>
                    </v-flex>
                    <v-text-field
                      @click="$refs.image.click()"
                      color="green"
                      placeholder="Select Image"
                      readonly
                      :value="promotion.file.name"
                    ></v-text-field>
                    <input
                      type="file"
                      style="display: none"
                      ref="image"
                      accept="image/*"
                      @change="pickFile($event)"
                    />
                  </v-flex>
                  <v-flex xs8 sm8 md8>
                    <v-text-field
                      label="Name*"
                      :rules="promotion.nameRules"
                      required
                      v-model="promotion.name"
                    ></v-text-field>
                    <v-autocomplete
                      v-model="promotion.products"
                      :items="products"
                      item-text="name"
                      item-value="id"
                      label="Products"
                      single-line
                      small
                      chips
                      multiple
                    >
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          class="chip--select-multi"
                          @input="remove(data.item)"
                        >
                          <v-avatar>
                            <img :src="data.item.image" />
                          </v-avatar>
                          {{ data.item.name }}
                        </v-chip>
                      </template>
                      <template v-slot="item" slot-scope="data">
                        <template v-if="(typeof data.item !== 'object')">
                          <v-list-tile-content
                            v-text="data.item"
                          ></v-list-tile-content>
                        </template>
                        <template v-else>
                          <v-list-tile-content>
                            <v-list-tile-title
                              v-html="data.item.name"
                            ></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-html="data.item.group"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <v-switch
                      v-model="promotion.active"
                      label="Available"
                      color="success"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              small
              outline
              @click.native="
                dialog1 = false;
                resetForm();
              "
              >Close</v-btn
            >
            <v-btn
              color="primary darken-1"
              small
              :disabled="!valid1 || uploading"
              @click.native="updatePromotion()"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog2" max-width="600px">
        <v-card>
          <v-card-title class="red--text"> Warning !! </v-card-title>
          <v-card-text class="pt-0">
            Error: Something went wrong... Please try again.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn color="blue" flat @click="dialog2 = false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script type="text/javascript">
import api from "@/api";
export default {
  data() {
    return {
      search: "",
      uploading: false,
      selectedPromotions: [],
      progress: 0,
      products: [],
      headers: [],
      promotions: [],
      deletedId: "",
      dialog: false,
      promotion: {
        image: "",
        name: "",
        active: true,
        products: [],
        nameRules: [(v) => !!v || "Name is required"],
        file: "",
        fileRules: [(v) => !!v || "file is required"],
        priceRules: [(v) => /^\d+(,\d{1,2})?$/.test(v) || "Enter Valid Price"],
        push_notification: false,
      },
      dialog: false,
      dialog2: false,
      dialog1: false,
      valid: false,
      valid1: false,
      confirm: false,
    };
  },
  watch: {
    vid() {
      this.reload();
    },
  },
  computed: {
    vid() {
      return this.$store.state.vid;
    },
  },
  methods: {
    loadPromotions() {
      let loader = this.$loading.show();
      api
        .get("promotions")
        .then((r) => {
          this.promotions = r.data;
          loader.hide();
        })
        .catch(async (err) => {
          loader.hide();
          if (err.message == "Network Error") {
            const res = await this.$dialog.confirm({
              text: "Please check your internet connection and try again",
              title: "Connection Failed",
              actions: [
                { text: "Cancel", color: "primary", key: false },
                { text: "Retry", color: "primary", key: true },
              ],
            });
            if (res) {
              this.loadPromotions();
            }
          }
        });
    },
    reload() {
      let loader = this.$loading.show();
      api
        .get("products",{params:{limit:1000}})
        .then((r) => {
          this.products = r.data;
        })
        .catch(async (err) => {
          loader.hide();
          if (err.message == "Network Error") {
            const res = await this.$dialog.confirm({
              text: "Please check your internet connection and try again",
              title: "Connection Failed",
              actions: [
                { text: "Cancel", color: "primary", key: false },
                { text: "Retry", color: "primary", key: true },
              ],
            });
            if (res) {
              this.reload();
            }
          }
        });
      api.get("promotions").then((r) => {
        loader.hide();
        this.promotions = r.data;
      });
    },
    pickFile(e) {
      if (e.target.files.length > 0) {
        this.promotion.file = e.target.files[0];
        this.promotion.image = URL.createObjectURL(this.promotion.file);

        this.uploadImage(this.promotion.file);
      }
    },
    uploadImage(file) {
      this.uploading = true;
      let formData = new FormData();
      formData.append("image", this.promotion.file);
      api
        .post("upload/file", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) =>
            (this.progress = progressEvent.total),
        })
        .then((r) => {
          if (r.data.file_url) {
            this.promotion.image = r.data.file_url;
            this.uploading = false;
          } else {
            this.dialog2 = true;
          }
        })
        .catch((err) => {
          this.dialog2 = true;
          this.uploading = false;
        });
    },
    addPromotion() {
      if (this.valid) {
        let loader = this.$loading.show();
        api
          .post("promotions", {
            image: this.promotion.image,
            name: this.promotion.name,
            active: this.promotion.active,
            products: this.promotion.products,
            push_notification: this.promotion.push_notification,
          })
          .then((r) => {
            loader.hide();
            this.loadPromotions();
            this.dialog = false;
            this.resetForm();
          })
          .catch((err) => {
            loader.hide();
            this.dialog2 = true;
          });
      }
    },
    editPromotion() {
      var c = this.selectedPromotions[0];
      this.promotion.id = c.id;
      this.promotion.name = c.name;
      this.promotion.image = c.image;
      this.promotion.file = "";
      this.promotion.products = c.products.map((p) => p.id);
      this.promotion.active = c.active;
      this.valid1 = false;
      this.dialog1 = true;
    },
    updateActive(id, v) {
      let loader = this.$loading.show();
      api
        .post("promotions/updateActive/" + id + "/" + v)
        .then((r) => {
          loader.hide();
        })
        .catch(async (err) => {
          loader.hide();
          if (err.message == "Network Error") {
            const res = await this.$dialog.confirm({
              text: "Please check your internet connection and try again",
              title: "Connection Failed",
              actions: [
                { text: "Cancel", color: "primary", key: false },
                { text: "Retry", color: "primary", key: true },
              ],
            });
            if (res) {
              this.updateActive(id, v);
            }
          }
        });
    },
    updatePromotion() {
      if (this.valid1) {
        let loader = this.$loading.show();
        api
          .put("promotions/"+this.promotion.id, {
            image: this.promotion.image,
            name: this.promotion.name,
            active: this.promotion.active,
            products: this.promotion.products,
          })
          .then((r) => {
            loader.hide();
            this.loadPromotions();
            this.resetForm();
            this.dialog1 = false;
          })
          .catch((err) => {
            loader.hide();
            this.dialog2 = true;
          });
      }
    },
    async deletePromotion() {
      var res = await this.$dialog.confirm({
        text: "Do you really want to delete?",
        title: "Warning",
      });
      if (res) {
        let loader = this.$loading.show();
        var deletedIds = [];
        this.selectedPromotions.forEach((p) => deletedIds.push(p.id));
        api
          .post("promotions/delete/", { deletedIds })
          .then((r) => {
            loader.hide();
            this.loadPromotions();
            this.selectedPromotions = [];
          })
          .catch(async (err) => {
            loader.hide();
            if (err.message == "Network Error") {
              const res = await this.$dialog.confirm({
                text: "Please check your internet connection and try again",
                title: "Connection Failed",
                actions: [
                  { text: "Cancel", color: "primary", key: false },
                  { text: "Retry", color: "primary", key: true },
                ],
              });
              if (res) {
                this.deletePromotion();
              }
            }
          });
      }
    },
    resetForm: function () {
      this.promotion = {
        image: "",
        name: "",
        active: true,
        products: [],
        nameRules: [(v) => !!v || "Name is required"],
        file: "",
        fileRules: [(v) => !!v || "File is required"],
        priceRules: [(v) => /^\d+(,\d{1,2})?$/.test(v) || "Enter Valid Price"],
      };
      this.selectedPromotions = [];
    },
    remove(item) {
      const index = this.promotion.products.indexOf(item.id);
      if (index >= 0) this.promotion.products.splice(index, 1);
    },
  },
  created() {
    if (this.vid) {
      api
        .get("products",{params:{limit:10000}})
        .then((r) => {
          this.products = r.data;
        })
        .catch(async (err) => {
          if (err.message == "Network Error") {
            const res = await this.$dialog.confirm({
              text: "Please check your internet connection and try again",
              title: "Connection Failed",
              actions: [
                { text: "Cancel", color: "primary", key: false },
                { text: "Retry", color: "primary", key: true },
              ],
            });
            if (res) {
              this.reload();
            }
          }
        });
      api.get("promotions").then((r) => {
        this.promotions = r.data;
      });
    }
    this.headers = [
      {
        sortable: false,
        text: "Image",
        value: "image",
        align: "center",
      },
      {
        sortable: true,
        text: "Name",
        value: "name",
        align: "left",
      },
      {
        sortable: true,
        text: "Active",
        value: "active",
        align: "left",
      },
      {
        sortable: false,
        text: "Products",
        align: "center",
      },
    ];
  },
};
</script>